import React from "react";
import { Card, Row, Col, Statistic, Spin, Empty, Progress, Table, Tag, Avatar } from "antd";
import {
  TrophyOutlined,
  SyncOutlined,
  TeamOutlined,
  RiseOutlined,
} from "@ant-design/icons";

const BadgeSection = ({ badgeStats, loading }) => {
  if (loading) {
    return (
      <Card title="Badges">
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!badgeStats) {
    return (
      <Card title="Badges">
        <Empty description="Sem dados de badges" />
      </Card>
    );
  }

  const columns = [
    {
      title: "Badge",
      dataIndex: "badgeName",
      key: "badgeName",
      ellipsis: true,
      render: (name, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            shape="square"
            size={32}
            src={record.badgeIcon || undefined}
            icon={!record.badgeIcon && <TrophyOutlined />}
            style={{ backgroundColor: !record.badgeIcon ? "#eb2f96" : undefined }}
          />
          <span style={{ fontWeight: 500 }}>{name}</span>
        </div>
      ),
    },
    {
      title: "Concluidos",
      dataIndex: "completed",
      key: "completed",
      width: 110,
      sorter: (a, b) => a.completed - b.completed,
      defaultSortOrder: "descend",
      render: (val) => <Tag color="green">{val}</Tag>,
    },
    {
      title: "Em Progresso",
      dataIndex: "inProgress",
      key: "inProgress",
      width: 120,
      sorter: (a, b) => a.inProgress - b.inProgress,
      render: (val) => <Tag color="blue">{val}</Tag>,
    },
    {
      title: "Usuarios",
      dataIndex: "totalUsers",
      key: "totalUsers",
      width: 100,
      sorter: (a, b) => a.totalUsers - b.totalUsers,
    },
    {
      title: "Progresso Medio",
      dataIndex: "avgProgress",
      key: "avgProgress",
      width: 150,
      sorter: (a, b) => a.avgProgress - b.avgProgress,
      render: (val) => (
        <Progress
          percent={val?.toFixed(0)}
          size="small"
          strokeColor={val >= 70 ? "#52c41a" : val >= 40 ? "#fa8c16" : "#ff4d4f"}
        />
      ),
    },
    {
      title: "Taxa Conclusao",
      key: "completionRate",
      width: 120,
      render: (_, record) => {
        const rate = record.totalUsers > 0
          ? ((record.completed / record.totalUsers) * 100).toFixed(1)
          : 0;
        const color = rate >= 50 ? "green" : rate >= 20 ? "orange" : "red";
        return <Tag color={color}>{rate}%</Tag>;
      },
      sorter: (a, b) => {
        const rateA = a.totalUsers > 0 ? a.completed / a.totalUsers : 0;
        const rateB = b.totalUsers > 0 ? b.completed / b.totalUsers : 0;
        return rateA - rateB;
      },
    },
  ];

  return (
    <div>
      <Card
        title={
          <span>
            <TrophyOutlined style={{ color: "#eb2f96", marginRight: 8 }} />
            Badges
          </span>
        }
      >
        <Row gutter={[16, 16]}>
          <Col xs={12} sm={8} lg={4}>
            <Statistic
              title="Concluidos"
              value={badgeStats.totalCompleted}
              prefix={<TrophyOutlined style={{ color: "#52c41a" }} />}
            />
          </Col>
          <Col xs={12} sm={8} lg={4}>
            <Statistic
              title="Em Progresso"
              value={badgeStats.totalInProgress}
              prefix={<SyncOutlined style={{ color: "#1890ff" }} />}
            />
          </Col>
          <Col xs={12} sm={8} lg={4}>
            <Statistic
              title="Total Usuarios"
              value={badgeStats.totalUsers}
              prefix={<TeamOutlined style={{ color: "#722ed1" }} />}
            />
          </Col>
          <Col xs={12} sm={8} lg={4}>
            <Statistic
              title="Progresso Medio"
              value={badgeStats.avgProgress?.toFixed(1)}
              suffix="%"
              prefix={<RiseOutlined style={{ color: "#fa8c16" }} />}
            />
          </Col>
          <Col xs={24} sm={16} lg={8}>
            <div style={{ paddingTop: 8 }}>
              <div style={{ marginBottom: 4, fontSize: 13, color: "#888" }}>
                Taxa de Conclusao
              </div>
              <Progress
                percent={badgeStats.completionRate?.toFixed(1)}
                strokeColor={{
                  "0%": "#eb2f96",
                  "100%": "#52c41a",
                }}
                format={(pct) => `${pct}%`}
              />
            </div>
          </Col>
        </Row>
      </Card>

      {badgeStats.ranking && badgeStats.ranking.length > 0 && (
        <Card
          title={
            <span>
              <TrophyOutlined style={{ color: "#faad14", marginRight: 8 }} />
              Ranking por Badge
            </span>
          }
          style={{ marginTop: 16 }}
          size="small"
        >
          <Table
            columns={columns}
            dataSource={badgeStats.ranking}
            rowKey="badgeId"
            pagination={false}
            size="small"
            scroll={{ x: 700 }}
          />
        </Card>
      )}
    </div>
  );
};

export default BadgeSection;
